module.exports = __webpack_public_path__ + "img/spo2.e6fa8ebe.png";